import { ca } from '@cian/analytics';

export function trackInterestRateBlock() {
  ca('eventSite', {
    action: 'show',
    label: 'Banner_conditions',
    category: 'Mortgage',
    name: 'oldevent',
  });
}
